const NIARA_DEFAULT_LOCALE_KEY = '_NIARA_DEFAULT_LOCALE'

export const getGlobalLocale = (defaultValue?: string) => {
  if (global[NIARA_DEFAULT_LOCALE_KEY]) return global[NIARA_DEFAULT_LOCALE_KEY]
  if (typeof navigator === 'object' && navigator) {
    if (navigator.language) return navigator.language
    if (navigator.languages && navigator.languages.length) return navigator.languages[0]
  }
  return defaultValue ?? 'pt-BR'
}

export const setGlobalLocale = (locale: string) => {
  global[NIARA_DEFAULT_LOCALE_KEY] = locale
  return locale
}
